import type { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom-v5-compat';

import { config } from '@/config/config';

import { useVaults } from '../../hooks';
import { selectActiveVaultId } from '../../services/selectors';

export interface VaultFirewallProps {
    children: ReactNode;
}

// Only a successfully loaded list proves a vault is unreachable. While it is pending — or when it
// failed — the records stay scoped by their own `vaultId`, which is correct without the list.
export const VaultFirewall = ({ children }: VaultFirewallProps) => {
    const activeVaultId = useSelector(selectActiveVaultId);
    const { vaults, query, isComplete } = useVaults();

    if (activeVaultId && query.isSuccess && isComplete && !vaults.some(({ id }) => id === activeVaultId)) {
        return <Navigate to={config.routes.secrets} replace />;
    }

    return <>{children}</>;
};
